import { render, staticRenderFns } from "./scorePage.vue?vue&type=template&id=675c9a1a&scoped=true"
import script from "./scorePage.vue?vue&type=script&lang=js"
export * from "./scorePage.vue?vue&type=script&lang=js"
import style0 from "./scorePage.vue?vue&type=style&index=0&id=675c9a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c9a1a",
  null
  
)

export default component.exports